/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum TypeCreditChanges {
  Manage = 1,
  BuyPackagePlan = 2,
  ExtendedPackagePlan = 3,
  Fish = 4,
  OnlinePayment = 5,
  PriceNumber = 6,
  ActivationService = 7,
  GiveBackCostOfUnsuccessSent = 8,
  ActivationGeneralPhoneBook = 9,
  SendSms = 10,
  DeleteUser = 11,
  TransferPrivateNumber = 12,
  PackagePurchase = 13,
  BenefitSendSms = 15,
  GiveBackBenefitSendSms = 16,
  PackagePurchaseDecrease = 17,
  PackageCancelDecrease = 18,
  PackageExpireDecrease = 19,
  PrivateNumberPurchase = 20,
  PackageCancelIncrease = 21,
  PackageExpireIncrease = 22,
  BuyModulePlan = 23,
  DeleteOrganization = 24,
  BuyPrivateReceiveKeyword = 25,
  SendSmsAmendment = 26,
  RejectPaymentAmendment = 27
}
